var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoRoundButton',_vm._g(_vm._b({attrs:{"icon":"copy","variant":"icon","aria-label":_vm.$t('ariaLabel')},on:{"click":_vm.copyToClipboard}},'CoRoundButton',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }